import React, { useState } from "react";
import { Input } from "antd";

const { Search } = Input;
const SearchBox = ({
  searchTerm,
  setSearchTerm,
  placeholder = "Search...",
  onSearch
}) => {
  const handleChange = (e) => {
    const { value } = e.target;
    if(onSearch){
      onSearch(value);
    }
    if(setSearchTerm){
      setSearchTerm(value);
    }
  
  };

  return (
    <div className="search_bar flex justify-center items-center px-4 py-2">
      <Search
        value={searchTerm}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-60 rounded-lg"
      />
    </div>
  );
};

export default SearchBox;
